import Blob from "../../art/Blob";
import "./ui.css";

export default function PageHero({ eyebrow, title, lede, tone = "#E6D2C3", children }) {
  return (
    <section className="phero" style={{ "--tone": tone }}>
      <Blob tone={tone} className="phero__blob drift" aria-hidden="true" />

      <div className="wrap wrap--wide phero__inner">
        <span className="eyebrow">{eyebrow}</span>
        <h1 className="phero__title">{title}</h1>
        {lede && <p className="phero__lede">{lede}</p>}
        {children}
      </div>
    </section>
  );
}
